var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavedDataLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 178,
    viewBox: "0 0 178 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.7786,
    y: 29.6126,
    width: 109,
    height: 149,
    rx: 4.5,
    transform: "rotate(-11.291 20.7786 29.6126)",
    fill: "white",
    stroke: "#00A3A4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.809,
    y: 24.5366,
    width: 109,
    height: 149,
    rx: 4.5,
    transform: "rotate(-6.85422 25.809 24.5366)",
    fill: "white",
    stroke: "#00A3A4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.3103,
    y: 17.5,
    width: 109,
    height: 149,
    rx: 4.5,
    fill: "white",
    stroke: "#00A3A4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.8103,
    y: 35,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#FAC23D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 88.8105,
    y: 39,
    width: 45,
    height: 5,
    rx: 2.5,
    fill: "#B0B0B0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 88.8105,
    y: 51,
    width: 45,
    height: 5,
    rx: 2.5,
    fill: "#B0B0B0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 88.8105,
    y: 63,
    width: 45,
    height: 5,
    rx: 2.5,
    fill: "#B0B0B0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 43.8103,
    y: 89,
    width: 90,
    height: 5,
    rx: 2.5,
    fill: "#E6E6E6"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 43.8103,
    y: 103,
    width: 90,
    height: 5,
    rx: 2.5,
    fill: "#E6E6E6"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 43.8103,
    y: 117,
    width: 90,
    height: 5,
    rx: 2.5,
    fill: "#E6E6E6"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 43.8103,
    y: 131,
    width: 90,
    height: 5,
    rx: 2.5,
    fill: "#E6E6E6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 43.8103,
    y: 145,
    width: 90,
    height: 5,
    rx: 2.5,
    fill: "#E6E6E6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 128.811,
    y: 2,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#00A3A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.814 17.3127C138.398 16.8215 137.676 16.7717 137.201 17.2015C136.726 17.6313 136.678 18.3779 137.093 18.8691L141.093 23.5964C141.537 24.121 142.321 24.1364 142.784 23.6296L152.499 12.9933C152.932 12.5188 152.911 11.7708 152.452 11.3226C151.994 10.8745 151.27 10.8958 150.837 11.3704L141.986 21.0616L138.814 17.3127Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedDataLight);
export default __webpack_public_path__ + "static/media/SavedDataLight.b181ae2daf82099f56c36b1bbb3b3d33.svg";
export { ForwardRef as ReactComponent };